var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "default-empty-data",
      style: "height:" + _vm.custom.height + ";",
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("img", {
            staticClass: "img",
            attrs: {
              src:
                _vm.custom.img ||
                require("@/assets/images/emptyDefault/emptyCard.png"),
              alt: "",
            },
          }),
          _vm.custom.title
            ? _c("h3", [_vm._v(_vm._s(_vm.custom.title))])
            : _vm._e(),
          !_vm.custom.slotText
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.custom.text || _vm.$t("system::common::btn::no_data")
                  )
                ),
              ])
            : _vm._e(),
          _vm._t("text"),
          _vm.custom.desc
            ? _c("span", { staticStyle: { "margin-top": "10px" } }, [
                _vm._v(_vm._s(_vm.custom.desc)),
              ])
            : _vm._e(),
          _vm.custom.buttons && _vm.custom.buttons.length > 0
            ? _c(
                "div",
                { staticClass: "btn-style" },
                [
                  _vm._l(_vm.custom.buttons, function (item, index) {
                    return [
                      !item.auth || _vm.authPromise(item.auth)
                        ? _c(
                            "el-button",
                            {
                              key: index,
                              attrs: {
                                type: item.type ? item.type : "primary",
                              },
                              on: { click: item.btnClick },
                            },
                            [_vm._v(" " + _vm._s(item.text) + " ")]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }